import { BaseCrudService } from "@/services/base";
import { ContactTraceResult, Reservation } from "@/swagger/models";

class ContactTraceService extends BaseCrudService<ContactTraceResult> {
    constructor() {
        super({
            apiPrefix: "contact-trace",
            entityName: "trace result",
        });
    }
}

export const contactTraceService = new ContactTraceService();
